import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-service-error',
    templateUrl: './service-error.component.html',
    styleUrl: './service-error.component.css',
    standalone: false
})
export class ServiceErrorComponent {

  supportUrl: string = 'https://support.proquest.com/s/product/proquest-platform';
}
